import type { OrderSummary as GQLOrderSummary } from '../generated/checkout.graphql';
import * as CheckoutEvent from './CheckoutEvent';
import * as PriceBreakdown from './PriceBreakdown';
import * as CheckoutCustomer from './CheckoutCustomer';
import * as OrderTicket from './OrderTicket';
import * as Address from './Address';
import { take } from '../util/takePayload';

export type OrderSummary = {
  fingerprint: string;
  state: 'draft' | 'awaiting_payment' | 'completed' | 'cancelled';
  address?: Address.Address;
  customer?: CheckoutCustomer.CheckoutCustomer;
  event?: CheckoutEvent.CheckoutEvent;
  breakdown?: PriceBreakdown.PriceBreakdown;
  items?: OrderTicket.OrderTicket[];
  orderConfirmationContent?: string | null;
};

export const fromGql = (gqlItem: GQLOrderSummary): OrderSummary => ({
  ...(take(gqlItem, 'fingerprint', 'state', 'orderConfirmationContent') as OrderSummary),
  customer: gqlItem.customer ? CheckoutCustomer.fromGQL(gqlItem.customer) : undefined,
  event: gqlItem.event ? CheckoutEvent.fromGql(gqlItem.event) : undefined,
  breakdown: gqlItem.breakdown ? PriceBreakdown.fromGql(gqlItem.breakdown) : undefined,
  items: (gqlItem.items || []).map(OrderTicket.fromGql),
  address: gqlItem.address ? Address.fromGql(gqlItem.address) : undefined,
});
